import Vue from 'vue';
import vuelidate from 'vuelidate';
import vueCustomElement from 'vue-custom-element';
import VueGtm from 'vue-gtm';
import { mediaQueries } from './media-query/media-query';
Vue.use(mediaQueries);
Vue.use(vueCustomElement);
Vue.use(vuelidate);
Vue.use(VueGtm, {});
